(function () {
  'use strict';
  if (window.minetanProductStickyWidgets) {
    window.minetanProductStickyWidgets.update();
    return;
  }

  var scheduled = false;
  var observedBars = new WeakSet();
  var observedRoots = new WeakSet();
  var chatLaunchers = new WeakSet();
  var sizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      update();
    });
  }

  function positionChatLauncher(button) {
    for (var launcher = button; launcher && launcher.nodeType === 1; launcher = launcher.parentElement) {
      var computed = getComputedStyle(launcher);
      if (computed.position !== 'fixed' || computed.bottom === 'auto') continue;
      if (!chatLaunchers.has(launcher)) {
        launcher.style.setProperty('--minetan-chat-bottom', computed.bottom);
        launcher.setAttribute('data-minetan-sticky-chat-launcher', '');
        chatLaunchers.add(launcher);
      }
      break;
    }
  }

  function updateChat() {
    // The current shopping assistant mounts in the document, not a shadow root.
    document.querySelectorAll('tolstoy-widget > button, button[aria-label="Open the shopping assistant"]').forEach(positionChatLauncher);
    var host = document.getElementById('chat-bubble-root');
    var root = host && host.shadowRoot;
    if (!root) return;
    if (!observedRoots.has(root)) {
      // Older Inbox launchers can be created or replaced after the bar is shown.
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
      observedRoots.add(root);
      var style = document.createElement('style');
      style.textContent = '[data-minetan-sticky-chat-launcher] { bottom: calc(var(--minetan-chat-bottom) + var(--product-sticky-height, 0px)) !important; }' +
        '@media (max-width: 1023px) { [data-minetan-sticky-chat-launcher] { left: var(--product-widget-left) !important; right: auto !important; bottom: calc(var(--product-widget-inset) + 75px + var(--product-sticky-height, 0px)) !important; } }';
      root.appendChild(style);
    }
    positionChatLauncher(root.querySelector('button'));
  }

  function update() {
    if (!document.body) return;
    var height = 0;
    document.querySelectorAll('.product-sticky-buttons').forEach(function (bar) {
      if (sizeObserver && !observedBars.has(bar)) {
        sizeObserver.observe(bar);
        observedBars.add(bar);
      }
      var style = getComputedStyle(bar);
      if (!bar.classList.contains('shown') || style.position !== 'fixed' ||
          style.display === 'none' || style.visibility === 'hidden') return;
      height = Math.max(height, Math.ceil(bar.getBoundingClientRect().height));
    });
    var value = height + 'px';
    // Consentmanager can mount its recall control outside body.
    var root = document.documentElement;
    root.setAttribute('data-product-sticky-widgets', '');
    if (root.style.getPropertyValue('--product-sticky-height') !== value) {
      root.style.setProperty('--product-sticky-height', value);
    }
    document.body.setAttribute('data-product-sticky-widgets', '');
    if (document.body.style.getPropertyValue('--product-sticky-height') !== value) {
      document.body.style.setProperty('--product-sticky-height', value);
    }
    updateChat();
  }

  window.minetanProductStickyWidgets = { update: schedule };
  // Includes sticky visibility changes and widgets inserted by asynchronous apps.
  new MutationObserver(function (records) {
    if (records.some(function (record) {
      return record.type === 'childList' || record.target === document.body ||
        (record.target.matches && record.target.matches('.product-sticky-buttons'));
    })) schedule();
  }).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['class']
  });
  window.addEventListener('resize', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
